import * as React from "react";

import { useFocusFinders } from "@fluentui/react-tabster";

export type FocusableRefProps = {
  /**
   * Callback ref to control focus on the group
   */
  firstFocusableRef?: React.Ref<{ focus: () => void }>;

  /**
   * Option to focus the selected element instead of first
   */
  focusSelected?: boolean;
};

export const useFirstFocusableRef = (
  props: FocusableRefProps,
  ref: React.RefObject<HTMLElement>
): void => {
  const { findFirstFocusable, findAllFocusable } = useFocusFinders();

  return React.useImperativeHandle(
    props.firstFocusableRef,
    () => ({
      focus: () => {
        if (ref?.current) {
          if (props.focusSelected) {
            const selectedElement = findAllFocusable(
              ref.current,
              (el) => el.getAttribute("aria-selected") === "true"
            );
            selectedElement[0]?.focus();
          } else {
            const firstFocusable = findFirstFocusable(ref.current);
            firstFocusable?.focus();
          }
        }
      },
    }),
    [ref, findFirstFocusable, findAllFocusable, props.focusSelected]
  );
};
